import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Field } from "react-final-form";
import FormField from "../components/FormField";
import SelectFormField from "lib/components/SelectFormField";

import {
  getSpreedlyToken,
  getSpreedlyYearError,
  getSpreedlyMonthError,
  triggerSpreedlyValidation,
} from "data/spreedly";

// Region/Country Dropdown Options
import Countries from "lib/utils/countries";
import StateOptions from "lib/utils/state-options";
import CanadaRegions from "lib/utils/canada-regions";

// Components
import SpreedlyForm from "../../../../shared/components/spreedly-form";
import DisplayError from "lib/components/DisplayError";

// Form Validations
import { required, email, composeValidators } from "lib/utils/FormValidations";

export class RegistrationForm extends Component {
  static propTypes = {
    tickets: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    cc_security: PropTypes.string.isRequired,
    customFields: PropTypes.array,
    cardExpiration: PropTypes.string,
    form_authenticity_token: PropTypes.string.isRequired,
    event_register_form: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      loading: false,
      isFreeRegistration: false,
      validating: false,
      first_name: props.event_register_form.purchaser_first_name,
      last_name: props.event_register_form.purchaser_last_name,
      country: "United States",
      region: "",
      month: "",
      year: "",
    };
  }

  componentDidMount() {
    const { tickets, handleTransition } = this.props;

    if (!Object.keys(tickets).length > 0) {
      handleTransition("tickets");
    }

    if (this.calculateTotalAmount(tickets) <= 0) {
      this.setState({
        isFreeRegistration: true,
      });
    }
  }

  calculateTotalAmount(tickets) {
    const ticketIds = Object.keys(tickets);

    if (ticketIds.length > 0) {
      return ticketIds.reduce((counter, id) => {
        if (tickets[id] && tickets[id].number && tickets[id].amount) {
          return counter + tickets[id].number * tickets[id].amount;
        }
        return counter;
      }, 0);
    } else {
      return 0;
    }
  }

  handleInput = (attr, e) => {
    this.setState({
      [attr]: e.target.value,
    });

    if (attr === "country") {
      this.setState({
        ["region"]: "",
      });
    }
  };

  renderLocationFields(className) {
    const { country } = this.state;
    let regions = StateOptions;
    let regionLabel = "State";
    let disabled = false;
    let placeholderText;

    // Placeholder Text
    if (!country) {
      placeholderText = "Select a country";
    } else if (country && country !== "United States" && country !== "Canada") {
      placeholderText = "";
    }

    // If Country is Canada, load CanadaRegions
    if (country && country === "Canada") {
      regions = CanadaRegions;
      regionLabel = "Province";
    }
    // Foreign Countries don't require region selection **disable select**
    else if (
      !country ||
      (country && country !== "United States" && country !== "Canada")
    ) {
      regions = [];
      disabled = true;
    }

    let requiredRegion = (value, allValues) =>
      allValues.purchaser_country === "United States" ||
      allValues.purchaser_country === "Canada"
        ? required(value)
        : undefined;

    return (
      <div className={className}>
        <SelectFormField
          disabled={false}
          options={Countries}
          fieldName="country"
          name="purchaser_country"
          label="Country"
          placeholder="Select Country"
          defaultValue={country}
          validate={required}
          classes="col-md-3"
          handleSelect={this.handleInput}
        />

        {country && (country === "United States" || country === "Canada") && (
          <SelectFormField
            disabled={disabled}
            options={regions}
            fieldName="region"
            name="purchaser_region"
            label={regionLabel}
            placeholder={placeholderText}
            validate={requiredRegion}
            classes="col-md-3"
            handleSelect={this.handleInput}
          />
        )}
      </div>
    );
  }

  formSubmit = (event) => {
    this.setState({ submitting: true });
  };

  runValidation = (e) => {
    const { triggerSpreedlyValidation } = this.props;
    const { isFreeRegistration } = this.state;

    if (isFreeRegistration) {
      this.setState({ submitting: true });
      $("#new_event_register_form").submit();
    } else {
      e.preventDefault();
      triggerSpreedlyValidation(true);

      this.setState({
        validating: true,
      });
    }
  };

  afterSpreedlyValidation = () => {
    this.setState({ submitting: true });

    // need to wait for the spreedly token to be set in the redux store
    setTimeout(() => {
      $("#new_event_register_form").submit();
    });
  };

  afterFailedSpreedlyValidation = () => {
    this.setState({
      submitting: false,
      validating: false,
    });
  };

  submitButton(disabled) {
    if (!this.props.event.registration_open) {
      return "";
    }
    const submitText = this.state.submitting ? "loading" : "Register Now";
    return (
      <button
        data-testid="t-Registr-submit"
        title="Register Now"
        type="submit"
        onClick={this.runValidation}
        className="register-modal-btn"
        disabled={disabled || this.state.submitting ? true : false}>
        {submitText}
      </button>
    );
  }

  renderTickets() {
    const { tickets, selected_tickets } = this.props;

    const hiddenFields = selected_tickets.map((ticket, key) => {
      return (
        <div key={key}>
          <input
            data-testid="t-Registr-event_register_formt"
            className="hidden form-control"
            name="event_register_form[tickets][][ticket_level_id]"
            type="hidden"
            value={tickets[ticket].ticket_level_id}
          />
          <input
            data-testid="t-Registr-event_register_formt"
            className="hidden form-control"
            name="event_register_form[tickets][][number]"
            type="hidden"
            value={tickets[ticket].number}
          />
          <input
            data-testid="t-Registr-event_register_formt"
            className="hidden form-control"
            name="event_register_form[tickets][][amount]"
            type="hidden"
            value={tickets[ticket].amount}
          />
          <input
            data-testid="t-Registr-event_register_formt"
            className="hidden form-control"
            name="event_register_form[tickets][][category]"
            type="hidden"
            value={tickets[ticket].category}
          />
        </div>
      );
    });

    return <div>{hiddenFields}</div>;
  }

  renderUserInfo(values) {
    let { country } = this.state;
    let zipLabel = country === "Canada" ? "Postal Code" : "Zip";

    return (
      <div>
        <div className="form-group">
          <Field
            label="First Name"
            fieldName="first_name"
            name="purchaser_first_name"
            validate={required}
            handleInput={this.handleInput}
            component={FormField}
            isRequired={true}
            classes=""
          />

          <Field
            label="Last Name"
            fieldName="last_name"
            name="purchaser_last_name"
            validate={required}
            handleInput={this.handleInput}
            component={FormField}
            isRequired={true}
            classes=""
          />
        </div>

        <div>
          <div className="form-group event_check">
            <label htmlFor="event_register_form_purchaser_attending" />
            <input
              id="event_register_form_purchaser_attending"
              defaultChecked={this.props.event_register_form.purchaser_attending}
              name="event_register_form[purchaser_attending]"
              value="yes"
              type="checkbox"
            />
            <span> I am attending this event.</span>
          </div>
        </div>

        <Field
          label="Email"
          fieldName="email"
          name="purchaser_email"
          validate={composeValidators(required, email)}
          handleInput={this.handleInput}
          component={FormField}
          placeholderText="ex: john@example.com"
          isRequired={true}
          classes="form-group"
        />

        <Field
          label="Phone"
          fieldName="phone"
          name="purchaser_phone"
          handleInput={this.handleInput}
          component={FormField}
          placeholderText="(###) ### - ####"
          isRequired={false}
          classes="form-group"
        />

        <Field
          label="Address"
          fieldName="address"
          name="purchaser_address1"
          validate={required}
          handleInput={this.handleInput}
          component={FormField}
          isRequired={true}
          classes="form-group"
        />

        <div className="row">
          {this.renderLocationFields()}

          <Field
            label="City"
            fieldName="city"
            name="purchaser_city"
            validate={required}
            handleInput={this.handleInput}
            component={FormField}
            isRequired={true}
            classes="form-group col-md-3"
          />

          <Field
            label={zipLabel}
            fieldName="zip"
            name="purchaser_zip"
            validate={required}
            handleInput={this.handleInput}
            component={FormField}
            isRequired={true}
            classes="form-group col-md-3"
          />
        </div>
      </div>
    );
  }

  renderCardInfo() {
    const { first_name, last_name, address, city, region, zip, country, phone } =
      this.state;

    const { expiredYearError, emptyMonthError } = this.props;

    const { updateCardExpiration, cardExpiration, spreedlyToken, spreedly_key } =
      this.props;

    const formatCCMonth = (value, name) => {
      if (value) {
        const val = value.replace(/\D/g, "");
        if (val.length > 2) {
          return val
            .match(/.{1,2}/g)
            .slice(0, 2)
            .join("/");
        } else {
          return val;
        }
      }
    };
    const [month, year] = cardExpiration ? cardExpiration.split("/") : [null, null];

    return (
      <div>
        <SpreedlyForm
          spreedlyKey={spreedly_key}
          afterSpreedlyValidation={this.afterSpreedlyValidation}
          afterFailedSpreedlyValidation={this.afterFailedSpreedlyValidation}
          first_name={first_name}
          last_name={last_name}
          month={month}
          year={year}
          address={address}
          city={city}
          region={region}
          zip={zip}
          country={country}
          phone={phone}
        />

        <input
          data-testid="t-Registr-event_register_forms"
          name="event_register_form[spreedly_cc_token]"
          type="hidden"
          value={spreedlyToken}
        />

        <Field
          name="card_expiration"
          label="Card Expiration"
          validate={required}
          handleInput={updateCardExpiration}
          value={cardExpiration}
          format={formatCCMonth}
          parse={formatCCMonth}>
          {({
            input: { name, value, onChange, ...inputRest },
            meta: { touched, error, ...metaRest },
            label,
            handleInput,
            ...props
          }) => (
            <div
              className={`${
                touched && error ? "form-group has-feeback has-error" : "form-group"
              }`}>
              <label className="required-field">{label}</label>
              <input
                name={`event_register_form[${name}]`}
                id={`event_register_form_${name}`}
                type="text"
                value={value || ""}
                onChange={(e) => {
                  onChange(e);
                  handleInput(e);
                }}
                placeholder="MM/YY"
                {...inputRest}
              />
              {touched && error && <span className="donation-error">{error}</span>}
              <DisplayError
                error={[expiredYearError, emptyMonthError]}
                className="donation-error"
              />
            </div>
          )}
        </Field>
      </div>
    );
  }

  calculateTotalTickets(tickets) {
    const keys = Object.keys(tickets);

    if (keys.length > 0) {
      let counter = 0;

      keys.forEach((id) => {
        counter += parseInt(tickets[id].number);
      });

      return counter;
    } else {
      return 0;
    }
  }

  renderFormConditional(values) {
    const {
      event: { registration_open },
    } = this.props;
    const { isFreeRegistration } = this.state;

    if (registration_open && isFreeRegistration) {
      return <fieldset>{this.renderUserInfo(values)}</fieldset>;
    } else if (registration_open) {
      return (
        <fieldset>
          {this.renderUserInfo(values)}
          {this.renderCardInfo(values)}
        </fieldset>
      );
    } else {
      return <p>Registration currently not open.</p>;
    }
  }

  handleBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  render() {
    const has_register_error =
      this.props.event_register_form &&
      this.props.event_register_form.errors &&
      this.props.event_register_form.errors.base &&
      this.props.event_register_form.errors.base.length;

    let header;

    if (this.props.event.registration_open) {
      header = (
        <div className="event-modal-top">
          <div>
            {has_register_error &&
              this.props.event_register_form.errors.base.map((error) => (
                <span className="event-modal-directions">{error} </span>
              ))}
          </div>
          <div className="percent-width-80">
            <h2 className="event-modal-header">Register for The Event</h2>
            <span className="event-modal-directions">
              Fill in the details in order to register to attend the event.
            </span>
          </div>
          <div className="percent-width-20">
            <div className="num-tickets-head-item primary-color-text">
              {this.calculateTotalTickets(this.props.tickets)}
            </div>
            <div className="num-tickets-head-title">Tickets</div>
          </div>
        </div>
      );
    } else {
      header = (
        <div className="event-modal-top">
          <h2 className="event-modal-header">registration is not currently open.</h2>
        </div>
      );
    }

    return (
      <Form
        data-testid="t-Registr-Form-7"
        onSubmit={this.formSubmit}
        initialValues={{
          purchaser_country: "Canada",
          purchaser_region: "",
        }}
        render={({ handleSubmit, reset, submitting, pristine, values, invalid }) => (
          <form
            acceptCharset="UTF-8"
            action={`/events/${this.props.event.slug}`}
            onSubmit={handleSubmit}
            className="new_event_register_form"
            id="new_event_register_form"
            method="post"
            noValidate="novalidate">
            <div className="hidden">
              <input
                data-testid="t-Registr-_method"
                name="_method"
                type="hidden"
                value="put"
              />
              <input data-testid="t-Registr-utf8" name="utf8" type="hidden" value="✓" />
              <input
                data-testid="t-Registr-authenticity_token"
                name="authenticity_token"
                type="hidden"
                value={this.props.form_authenticity_token || ""}
              />
              <input
                id="event_register_form_event_id"
                className="hidden form-control"
                name="event_register_form[event_id]"
                type="hidden"
                value={this.props.event.id || ""}
              />

              {this.renderTickets()}
            </div>
            <div className="event-modal">
              <div className="event-modal-background">
                {header}
                <div className="event-modal-body">
                  <div className="event-modal-form">
                    <i
                      onClick={this.handleBack}
                      className="fa fa-arrow-circle-left primary-color-text f-1.5x m-sm-r pointer"
                      aria-hidden="true"
                    />
                    Back
                    {this.renderFormConditional(values)}
                  </div>
                </div>
                <div className="event-modal-bottom">
                  {this.submitButton(pristine || invalid)}
                </div>
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    spreedlyToken: getSpreedlyToken(state),
    expiredYearError: getSpreedlyYearError(state),
    emptyMonthError: getSpreedlyMonthError(state),
  };
};

const mapActionCreators = {
  triggerSpreedlyValidation,
};

export default withRouter(connect(mapStateToProps, mapActionCreators)(RegistrationForm));
